import React from "react";
import { narrationSource } from "@shared/lib/media";
import NewAudioPlayer from "@visitor/components/NewAudioPlayer";
import AudioPlayer from "@visitor/components/AudioPlayer";

// F-F visitor narration. Resolves the playback source by precedence
// (F-F Q-1): a stored narration asset → the legacy voice_url → browser TTS.
// Stored/legacy audio plays through the existing <NewAudioPlayer>; the TTS
// fallback uses the existing <AudioPlayer>. All three are mutually exclusive
// with the gallery via the page-level single-playback coordinator — the
// onPointerDownCapture here pauses any playing <audio> right before TTS starts
// (the audio→TTS direction is handled by the capture-phase "play" listener).
//
// `entity` is owner-agnostic — an exhibit OR a zone; both carry the narration
// fields read by narrationSource(). camelCase wire fields per ADR-0020.

// Browser-TTS fallback kill switch (2026-08-11 manual review): with no
// stored narration and no legacy URL, items now show no narration at all.
// Flip to true to restore the device text-to-speech fallback — the full
// code path below is kept intact for exactly that.
export const ENABLE_BROWSER_TTS = false;

const NarrationControl = ({ entity, language, text, api, onTtsStart }) => {
  if (!entity || !language) return null;

  const source = narrationSource(entity, language);

  if (source.type === "asset") {
    return <NewAudioPlayer audioUrl={`${api}/assets/${source.assetId}`} />;
  }
  if (source.type === "voice") {
    return <NewAudioPlayer audioUrl={source.url} />;
  }

  // TTS fallback — only meaningful when enabled and there's text to speak.
  if (!ENABLE_BROWSER_TTS || !text) return null;
  return (
    <div onPointerDownCapture={onTtsStart} data-testid="narration-tts">
      <AudioPlayer text={text} language={language} />
    </div>
  );
};

export default NarrationControl;
